import React from 'react';
import { Spin, Alert, Switch, Divider } from 'antd';

class Card extends React.Component {
  state = { loading: true };

  toggle = value => {
    this.setState({ loading: value });
  };

  render() {
    const container = (
      <Alert
        message="Alert message title"
        description="Further details about the context of this alert."
        type="info"
      />
    );
    return (
      <div>
        <Spin spinning={false} delay={500}>
          {container}
        </Spin>
        <Divider orientation="left"></Divider>
        <Spin spinning={this.state.loading} delay={500}>
          {container}
        </Spin>
        <Divider orientation="left"></Divider>
        <Spin spinning={false} delay={500}>
          {container}
        </Spin>
        

        {/* <div style={{ marginTop: 16 }}>
          Loading state：
          <Switch checked={this.state.loading} onChange={this.toggle} />
        </div> */}
      </div>
    );
  }
}

export default Card